module.exports = __webpack_public_path__ + "img/storage_black.d2b41990.png";